module.exports = __webpack_public_path__ + "static/media/michpal_clock_in.b7ad57ca.png";